import React from 'react';
import TabDataTable from '../../../components/tab-data-table/tab-data-table';
import { TableDataHeader } from '@block-explorer/ui';
import { TableRow } from '@make-software/cspr-design';
import { Trans, useTranslation } from 'react-i18next';
import { useGetAccountCep18TokenList } from '../../../hooks/event-store-hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Cep18TokenItem, PageDataTable } from '../../../components';
import { sortTokensByBalances } from '../../../services';

interface AccountCep18ListProps {
  accountHash: string;
  pageSize?: number;
  showTopPagination?: boolean;
}

const AccountTokensList = ({
  accountHash,
  pageSize = 10,
  showTopPagination,
}: AccountCep18ListProps) => {
  const { t } = useTranslation();

  const { selectedCurrency: currency } = useSelector(
    (state: RootState) => state.currencies
  );

  const {
    data: accountCep18Tokens,
    loading: accountCep18TokensLoading,
    error,
    sortingProps,
    paginationProps,
  } = useGetAccountCep18TokenList(
    accountHash
      ? {
          accountHash,
          includes: `contract_package,token_market_data(${currency.id})`,
          defaultPageSize: pageSize,
        }
      : null
  );

  const tokens = sortTokensByBalances(accountCep18Tokens);

  const TableComponent = showTopPagination ? PageDataTable : TabDataTable;

  return (
    <TableComponent
      loading={accountCep18TokensLoading}
      data={tokens}
      error={error}
      sortingProps={sortingProps}
      paginationProps={paginationProps}
      renderDataHeader={() => (
        <TableRow>
          <TableDataHeader fixedWidthRem={40}>
            <Trans t={t}>Token</Trans>
          </TableDataHeader>
          <TableDataHeader fixedWidthRem={30}>
            <Trans t={t}>Price</Trans>
          </TableDataHeader>
          {/*<TableDataHeader fixedWidthRem={35}>*/}
          {/*  <Trans t={t}>24h Price</Trans>*/}
          {/*</TableDataHeader>*/}
          <TableDataHeader fixedWidthRem={20} align={'right'}>
            <Trans t={t}>Balance</Trans>
          </TableDataHeader>
          <TableDataHeader fitContent align={'center'} />
        </TableRow>
      )}
      renderPaginatedData={(tokens) =>
        tokens.map((token, idx) => (
          <Cep18TokenItem
            data={token}
            hash={accountHash}
            key={`cep-18-token-${idx}`}
            loading={accountCep18TokensLoading}
          />
        ))
      }
    />
  );
};

export default AccountTokensList;
